// Base URL for large media (video, oversized downloads). These files live in the
// Cloudflare R2 bucket `portfolio-media`, served at media.shareefjasim.com, because
// Workers static assets reject files over 25 MiB. Everything else stays in public/.
export const MEDIA_BASE = "https://media.shareefjasim.com";
